

// verifyCondition_writeMessage: Esta función verifica si se cumple la condición para que se 
// renderice el componente.
export const  verifyCondition_writeMessage = (sessionSelected, socketConnected, filesSelected, sessionsChatSelected) => {
    let condition = (
        sessionSelected.IdSession /* &&
        sessionSelected.Fin === null */ &&
        socketConnected &&
        filesSelected.length === 0 &&
        sessionsChatSelected.length > 0
    );
    return condition;
}
